<template>
    <div class="page" id="profile">
        <header class="pageHeader">
            <div class="pageHeaderIntro">
                <h1>
                    Hi <span class="capitalise">{{ user.first_name }}</span
                    >!
                </h1>
                <p data-cy="welcome">Welcome back to Lesson Pro</p>
                <img class="icon" src="~@/assets/icons/headers/profile.svg" />
            </div>
        </header>

        <div id="scroller">
            <router-link id="nextLesson" :to="{ name: 'playerLessons' }" v-if="next_lesson">
                <span class="title"
                    >Next Lesson:
                    <calendar-icon class="calendar"></calendar-icon>
                </span>
                <span class="date">{{ $date(next_lesson.time).format("DD MMM") }}</span>
                <chevron-right-icon class="icon"></chevron-right-icon>
            </router-link>
            <router-link
                id="nextLesson"
                :to="{ name: 'BookChooseType' }"
                v-else-if="$store.state.user.lesson_settings.video_lessons_enabled"
            >
                <span class="title"
                    >Book Lesson:
                    <calendar-icon class="calendar"></calendar-icon>
                </span>
                <chevron-right-icon class="icon"></chevron-right-icon>
            </router-link>
            <router-link id="nextLesson" :to="{ name: 'BookLesson' }" v-else>
                <span class="title"
                    >Book Lesson:
                    <calendar-icon class="calendar"></calendar-icon>
                </span>
                <chevron-right-icon class="icon"></chevron-right-icon>
            </router-link>

            <router-link id="bag" :to="{ name: 'playerBag' }">
                <span class="title">What's in the bag:</span>
                <chevron-right-icon class="icon"></chevron-right-icon>
            </router-link>

            <skills-score />

            <yardages-list />
        </div>
    </div>
</template>

<script>
import { CalendarIcon, ChevronRightIcon } from "vue-feather-icons";
import skillsScore from "@/components/Player/Skills-score";
import YardagesList from "@/components/Player/Yardages/Yardages-list";
export default {
    name: "player-profile",
    components: { skillsScore, CalendarIcon, ChevronRightIcon, YardagesList },
    computed: {
        user() {
            return this.$store.state.user;
        },
        next_lesson() {
            return this.$store.state.user.next_lesson;
        },
    },
};
</script>

<style lang="scss" scoped>
#profile {
    #nextLesson,
    #bag {
        border-radius: 15px;
        margin-bottom: 10px;
        padding: 20px;
        position: relative;
        text-decoration: none;
        .icon {
            color: white;
            position: absolute;
            bottom: 10px;
            right: 10px;
        }
        .title {
            color: white;
            display: block;
            margin-bottom: 10px;
        }
    }
    #nextLesson,
    #bag {
        width: calc(50% - 5px);
        height: 124px;
        float: left;
        .date {
            color: white;
            font-size: 26px;
        }
    }
    #nextLesson {
        background: $green_1;
        margin-right: 10px;

        .calendar {
            width: 20px;
            color: $green_2;
            position: absolute;
            top: -5px;
            right: -5px;
        }
    }
    #bag {
        background-color: $green_2;
        background-image: url("~@/assets/icons/golf-bag.svg");
        background-repeat: no-repeat;
        background-position: 20px 103%;
        .title {
            color: $green_0;
        }
        .icon {
            color: $green_0;
        }
    }
}
</style>
